<template>
  <div class="key-container">

    <div class="keyRow">
      <span 
      v-for="key of firstKeys" 
      :key="key" 
      :id=key 
      class="key" 
      @click="addLetter(key)">
        {{key}}
      </span>
    </div>

    <div class="keyRow">
      <span 
      v-for="key of secondKeys" 
      :key="key" 
      :id=key 
      class="key" 
      @click="addLetter(key)">
        {{key}}
      </span>
    </div>

    <div class="keyRow">
      <span 
      v-for="key of thirdKeys" 
      :key="key" 
      :id=key 
      class="key" 
      @click="addLetter(key)">
        {{key}}
      </span>
    </div>

    <modal ref="statistics">
      <template v-slot:header>
        <h3>WORDLE ARGENTO #{{this.wordleNumber}}</h3>
      </template>

      <template v-slot:body>
          <p v-if="this.gameOver == 'true'" v-html='this.lastEmojiSquares'></p>
          <p v-if="this.gameOver == 'true'">La palabra era: <span style="text-transform: uppercase">{{this.secretWord}}</span></p>

          <h3>ESTADÍSTICAS</h3>

          <div class="stats__container">
            <div class="jugadas">
              <span v-if="this.gamesPlayed == null" style="font-size: 30px">0</span>
              <span v-else style="font-size: 30px">{{this.gamesPlayed}}</span>
              <span>jugadas</span>
            </div>
            <div class="victorias">
              <span v-if="this.percentage == null" style="font-size: 30px">0%</span>
              <span v-else style="font-size: 30px">{{this.percentage}}%</span>
              <span>victorias</span>
            </div>

            <div class="nextWord">
              <strong>Siguiente palabra</strong>
              <div>
                {{this.hours}}:{{this.minutes}}:{{this.seconds}}
              </div>
            </div>
            <div class="shareGuess" @click="copyToClipboard()">Compartir resultado</div>
          </div>
      </template>
    </modal>

  </div>
</template>
<script>
import Modal from '@/components/Modal.vue'

const epochMs = new Date('February 26, 2022 00:00:00').valueOf()
const now = Date.now()
const msInDay = 86400000
const index = Math.floor((now - epochMs) / msInDay)
const nextday = (index + 1) * msInDay + epochMs

function prependZero(number) {
  if (number < 9){
    return "0" + number
  }else{
    return number
  }
}

export default {
  components:{
    Modal
  },
  data(){
    return{
      hours: true,
      minutes: true,
      seconds: true,

      lastEmojiSquares: null
      }
    },
  computed:{
    firstKeys(){
      return this.$store.state.firstKeys
    },
    secondKeys(){
      return this.$store.state.secondKeys
    },
    thirdKeys(){
      return this.$store.state.thirdKeys
    },
    currentTile(){
      return this.$store.state.currentTile
    },
    currentRow(){
      return this.$store.state.currentRow
    },
    guessRows(){
      return this.$store.state.guessRows
    },
    secretWord(){
      return this.$store.state.secretWord
    },

    rightWords(){
      return this.$store.state.completedDictionary
    },

    wordsElements(){
      return this.$store.state.wordsElements
    },

    won(){
      return this.$store.state.won
    },
    percentage(){
      return this.$store.state.percentage
    },
    gameOver(){
      return this.$store.state.gameOver
    },
    gamesPlayed(){
      return this.$store.state.gamesPlayed
    },
    wordleNumber(){
      return this.$store.state.solutionIndex
    },

    oldEmojiSquares(){
      return this.$store.state.oldEmojiSquares
    }
  },
  methods: {
    setEmojiSquares(){
      window.localStorage.setItem('oldEmojiSquares', JSON.stringify(this.wordsElements))

      var emojiSquares = this.wordsElements.join('').split(/(.{5})/).filter(e => e).join('<br>')

      const greenS = /a/g
      const yellowS = /c/g
      const greyS = /d/g

      emojiSquares = emojiSquares.replace(greenS, '🟩')
      emojiSquares = emojiSquares.replace(yellowS, '🟨')
      emojiSquares = emojiSquares.replace(greyS, '⬛')

      this.lastEmojiSquares = emojiSquares
    },

    addLetter(key){
      if(window.localStorage.getItem('gameOver') === null || window.localStorage.getItem('gameOver') === 'false'){

        if(this.firstKeys.includes(key) || this.secondKeys.includes(key) || this.thirdKeys.includes(key) || key === 'Backspace' || key === 'Enter'){
          if (key === '⌫' || key === 'Backspace'){
            this.deleteLetter()
            return

          }else if ( key === 'ENTER' || key === 'Enter' ){
            this.checkRow()
            return

          }else if( this.currentTile < 5 && this.currentRow < 6 ){
            this.$store.commit('oneMoreCurrentTile', key)
          }
        }
      }
    },

    deleteLetter(){
      if(this.currentTile > 0){ //it won't let you delete more letters when you're in the first tile
        this.$store.commit('deleteCurrentTile')
      }
    },

    checkRow(){
      const word = this.$store.state.guessRows[this.currentRow].join('')

        if(this.currentTile > 4){

        if(this.rightWords.includes(word)){

          if(this.secretWord == word){
            this.forEachColors()
            this.$store.commit('youWin')
            this.$store.commit('updatewon')
            this.$store.commit('gamesPlayed')

            setTimeout(() => {
              this.setEmojiSquares()
              this.$refs.statistics.openModal()
            }, 1000)

            this.$store.commit('setRows')

            window.localStorage.setItem('myGuesses', JSON.stringify(this.guessRows))
            window.localStorage.setItem('lastWord', this.secretWord)
            return

          }else{
            if(this.currentRow >= 5){
              this.forEachColors()
            
              this.$store.commit('youLose')
              this.$store.commit('gamesPlayed')

              setTimeout(() => {
                this.setEmojiSquares()
                this.$refs.statistics.openModal()
              }, 1000)

              this.$store.commit('setRows')

              window.localStorage.setItem('myGuesses', JSON.stringify(this.guessRows))
              window.localStorage.setItem('lastWord', this.secretWord)
              return

            }else if(this.currentRow < 5){
              this.forEachColors()
              this.$store.commit('nextRow')
            }
          }
        }else{
          this.$store.commit('incorrectWord')
          return
        }

      }else if(this.currentTile <= 4){
        this.$store.commit('lessLetters')
      }
    },

    forEachColors(){
      const word = this.$store.state.guessRows[this.currentRow].join('')
      const possibleLetters = word.split('')
      const letters = document.getElementById(this.currentRow).getElementsByClassName('letter')

      possibleLetters.forEach((letter, index) => {
        const exactLetter = letter === this.secretWord[index]
        const thisSecretWord = this.secretWord

        setTimeout(() => {
          if(exactLetter){
            letters[index].classList.add('green-overlay')
            this.addColorToKey(letter, 'green-overlay')
            letters[index].classList.add('whiteColor')

            this.$store.commit('generateGreenSquare')

          }else if(thisSecretWord.includes(letter)){
            letters[index].classList.add('yellow-overlay')
            this.addColorToKey(letter, 'yellow-overlay')
            letters[index].classList.add('whiteColor')

            this.$store.commit('generateYellowSquare')

          }else{
            letters[index].classList.add('grey-overlay')
            this.addColorToKey(letter, 'grey-overlay')
            letters[index].classList.add('whiteColor')

            this.$store.commit('generateGreySquare')
          }
        }, 150 * index)
      })
    },

    addColorToKey(letter, overlay){
      document.getElementById(letter).classList.add(overlay)
    },

    timeLeft(){
      setInterval(() => {
      const now = new Date().getTime()
      var timeleft = nextday - now

      this.hours = prependZero(Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
      this.minutes = prependZero(Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60)))
      this.seconds = prependZero(Math.floor((timeleft % (1000 * 60)) / 1000))

      if (this.hours == '00' && this.minutes == '00' && this.seconds == '00') {
        location.reload()
        window.localStorage.removeItem('lastWord')
      }
      }, 1000)
    },

    copyToClipboard(){
      const linebreak = '<br>'
      var emojiSquares = this.lastEmojiSquares

      var copyEmojiSquares = emojiSquares.replace(new RegExp(linebreak, "g"), '\n')

      navigator.clipboard.writeText('Wordle Argento #' + this.wordleNumber + '\n' + '\n' + copyEmojiSquares + '\n' + '\n' + 'https://wordleargento.vercel.app')

      this.$store.commit('copiedToClipboard')
    }
  },
  beforeCreate(){
    this.$store.commit('getWord')
  },
  beforeMount(){
    this.timeLeft()

    if(window.localStorage.getItem('gameOver') === null || window.localStorage.getItem('gameOver') === 'false'){
      document.addEventListener("keyup", (k) => this.addLetter(k.key))
    }
  }
}
</script>
<style lang="scss">
.key-container{
  display: flex;
  flex-direction: column;
}
.keyRow{
  display: flex;
  justify-content: space-between;
}
.key{
  display: flex;
  background-color: #818384;
  color: #fff;
  font-weight: 400;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
  padding: 12px;
  margin: 2px 2px;
  min-width: 10px;
  max-width: 12px;
  justify-content: center;
  align-items: center;
}
#ENTER{
  max-width: 40px;
}

.container .letter.pop{
  animation: pop 0.25s ease-in-out 1 forwards;
}
@keyframes pop{
  0%, 100% {transform: scale(1)}
  50% {transform: scale(1.15)}
}

.container .letter.flip{
  animation: 0.5s linear flipping;
}
@keyframes flipping{
  0%{transform: rotateX(0deg)}
  50%{transform: rotateX(90deg)}
  100%{transform: rotateX(0deg)}
}

.header{
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 1px solid #555;
  display: flex;
  justify-content: space-between;
  align-items: center;
    h1{
      font-size: 30px;
    }
}
img{
  height: 20px;
  cursor: pointer;
}

.info__text{
  text-align: left;
  padding: 0 20px;
  box-sizing: border-box;
  a{
    color: #737373;
  }
}

.stats__container{
  display: grid;
  grid-template-areas:
    "jugadas victorias"
    "nextWord shareGuess";
  text-align: center;
  align-items: center;
  text-transform: uppercase;
  grid-gap: 50px;
  margin: auto;
}
.jugadas{grid-area: jugadas}
.victorias{grid-area: victorias}
.nextWord{grid-area: nextWord}
.shareGuess{
  grid-area: shareGuess;
  padding: 10px;
  box-sizing: content-box;
  background-color: #6aaa64;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
}

.nextWord, .shareGuess, .victorias, .jugadas{
  display: flex;
  flex-direction: column;
}

.whiteColor{
  color: #f5f5f5 !important;
}

@media screen and (max-width: 500px){
.stats__container{
  grid-template-areas:
    "jugadas victorias"
    "nextWord nextWord"
    "shareGuess shareGuess";
  }
}

.progress-container{
  display: flex;
  margin: 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  align-self: center;
  text-align: center;
}
.progress{
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  grid-area: percentage;
  width: 200px;
  margin: auto
}
.progress-bar{
  background-color: var(--text-color);
  color: var(--background-color)
}
</style>